import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesPreview from './components/ServicesPreview';
import AreasPreview from './components/AreasPreview';
import WhyUs from './components/WhyUs';
import Testimonials from './components/Testimonials';
import CTABanner from './components/CTABanner';

export default function HomePage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://example.com';

    const existingScript = document.getElementById('schema-home');
    if (existingScript) existingScript.remove();

    const schema = {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebSite',
          '@id': `${siteUrl}/#website`,
          url: siteUrl,
          name: 'Alfa \u00c7ilingir',
          description: 'Beylikd\u00fcz\u00fc, Esenyurt, B\u00fcy\u00fck\u00e7ekmece ve Bah\u00e7e\u015fehir\'de 7/24 profesyonel \u00e7ilingir hizmeti.',
          inLanguage: 'tr-TR',
          potentialAction: {
            '@type': 'SearchAction',
            target: `${siteUrl}/?s={search_term_string}`,
            'query-input': 'required name=search_term_string',
          },
        },
        {
          '@type': 'LocalBusiness',
          '@id': `${siteUrl}/#localbusiness`,
          name: 'Alfa \u00c7ilingir',
          url: siteUrl,
          telephone: '+905416247982',
          description: 'Beylikd\u00fcz\u00fc, Esenyurt, B\u00fcy\u00fck\u00e7ekmece ve Bah\u00e7e\u015fehir\'de 7/24 profesyonel \u00e7ilingir hizmeti. Acil kap\u0131 a\u00e7ma, kilit de\u011fi\u015ftirme, \u00e7elik kap\u0131 a\u00e7ma.',
          address: {
            '@type': 'PostalAddress',
            addressLocality: 'Beylikd\u00fcz\u00fc',
            addressRegion: '\u0130stanbul',
            addressCountry: 'TR',
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: 41.0,
            longitude: 28.64,
          },
          openingHoursSpecification: [
            {
              '@type': 'OpeningHoursSpecification',
              dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
              opens: '00:00',
              closes: '23:59',
            },
          ],
          areaServed: ['Beylikd\u00fcz\u00fc', 'Esenyurt', 'B\u00fcy\u00fck\u00e7ekmece', 'Bah\u00e7e\u015fehir'],
          priceRange: '\u20ba\u20ba',
          foundingDate: '2014',
        },
      ],
    };

    const script = document.createElement('script');
    script.id = 'schema-home';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById('schema-home');
      if (s) s.remove();
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <ServicesPreview />
        <AreasPreview />
        <WhyUs />
        <Testimonials />
        <CTABanner />
      </main>
      <Footer />
    </>
  );
}
